import {Card} from 'antd'
import {Params, useFetchGet} from 'helpers/api'
import {useEffect, useState} from 'react'
import ApexChart from 'react-apexcharts'

// Generate blue tone from light blue to deep blue
const blueToneColor = ratio => {
  const lightness = 95 - ratio * 70 // 85% (light blue) to 35% (deep blue)
  return `hsl(210, 100%, ${lightness}%)`
}

export const TemperatureHistogramCard = ({query, width}) => {
  const [data, setData] = useState()
  const [options, setOptions] = useState({})
  const [series, setSeries] = useState()

  const fetchTargetsview = useFetchGet('targetsview')

  const getTargetsview = () => {
    const params = Params({...query, count: 'tp_max_5x'})
    fetchTargetsview(params, response => {
      const result = response.targetsview

      const tpMaxValues = result.map(item => item.tp_max_5x)
      const minTpMax = Math.min(...tpMaxValues)
      const maxTpMax = Math.max(...tpMaxValues)

      const numbers = []
      for (let i = minTpMax - 5; i <= maxTpMax + 5; i += 5) {
        numbers.push(i)
      }

      const counts = Array(numbers.length).fill(0)
      result.forEach(item => {
        const index = numbers.indexOf(item.tp_max_5x)
        if (index !== -1) {
          counts[index] = item.count
        }
      })

      const min = Math.min(...numbers)
      const max = Math.max(...numbers)

      const colors = numbers.map(val => {
        const ratio = (val - min) / (max - min)
        return blueToneColor(ratio)
      })

      // 🟦 Convert to F + label: "F (C)"
      const categories = numbers.map(c => {
        const f = Math.round((c * 9) / 5 + 32)
        return `${f}°F (${c}°C)`
      })

      setData({numbers, counts, colors, categories})
    })
  }

  useEffect(() => {
    if (query) getTargetsview()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query])

  useEffect(() => {
    if (data) {
      setSeries([
        {
          name: 'Temperature',
          data: data.counts
        }
      ])
      setOptions({
        chart: {
          height: 350,
          type: 'bar',
          dropShadow: {
            enabled: true,
            color: '#000',
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2
          },
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false
          }
        },
        title: {
          text: 'Temperatures',
          align: 'left',
          margin: 0,
          offsetX: 0,
          offsetY: 0,
          floating: false,
          style: {
            fontSize: '20px',
            fontWeight: 'bold',
            fontFamily: undefined,
            color: 'black'
          }
        },
        plotOptions: {
          bar: {
            distributed: true,
            borderRadius: 4,
            borderRadiusApplication: 'end',
            horizontal: false
          }
        },
        dataLabels: {
          enabled: true
        },
        xaxis: {
          categories: data.categories
        },
        tooltip: {
          x: {
            formatter: function (val) {
              const c = parseInt(val.split('°F')[1]) // Get °C part from label
              const startF = parseInt(val)
              const endF = Math.round(((c + 4) * 9) / 5 + 32)
              return `${startF}–${endF}°F`
            }
          }
        },
        legend: {
          show: false
        },
        colors: data.colors
      })
    } else {
      setOptions({})
    }
  }, [data])

  return (
    <Card className={`w-${width} h-52 font-bold`}>
      {data && series ? (
        <ApexChart options={options} series={series} type="bar" height={180} width={width * 0.9} />
      ) : (
        <></>
      )}
    </Card>
  )
}
